// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2A5kE","left":"InfoRow_left__tw0VD"};